
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_62533_85)","stroke":"currentColor"}},[_c('path',{attrs:{"d":"M7.417 7.417A.583.583 0 018 8v2.917a.583.583 0 00.583.583M15 8A7 7 0 111 8a7 7 0 0114 0z","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7.708 5.667a.875.875 0 100-1.75.875.875 0 000 1.75z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_62533_85"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    